export default __webpack_public_path__ + "static/media/logo192.d6fd2e31.png";